import { useContext, useEffect, useState } from "react";
import { Account } from "../Main";
import { fetchWithAuth, parseData } from "../Utils";
import "./PopupSfide.css";
import Popup from "./Popup";

const PopupSfide = ({ onClose, onAggiornaClassifica }) => {

    const { persona, showAlert } = useContext(Account);

    const [sfide, setSfide] = useState([]);
    const [prenotazioni, setPrenotazioni] = useState([]);
    const [loading, setLoading] = useState(false);

    const [filtroStato, setFiltroStato] = useState("tutte");

    useEffect(() => {
        caricaSfide();
        caricaPrenotazioni();
    }, []);

    const caricaSfide = async () => {

        setLoading(true);

        const res = await fetchWithAuth(
            "classifica_mobile_get_sfide.php",
            {},
            "GET"
        );

        if (res.ok) {
            setSfide(res.sfide);
        }

        setLoading(false);
    };

    const caricaPrenotazioni = async () => {

        const res = await fetchWithAuth(
            "visualizza_prenotazione.php",
            {},
            "GET"
        );

        const today = new Date();

        const giornoAttuale = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate()
        );

        if (res.ok) {

            setPrenotazioni(
                res.prenotazioni.filter(
                    x => parseData(x.data) >= giornoAttuale
                )
            );
        }
    };

    const ritiraSfida = async (idSfida) => {

        if (!window.confirm(
            "Ritirare la sfida? Lo sfidato non potrà più accettarla."
        )) return;

        const res = await fetchWithAuth(
            "classifica_mobile_ritira_sfida.php",
            {
                method: "POST",
                body: JSON.stringify({
                    IDSfida: idSfida
                })
            }
        );

        if (res.ok) {

            showAlert("Successo", "Sfida ritirata");

            caricaSfide();
            onAggiornaClassifica();

        } else {

            showAlert("Errore", res.error);
        }
    };

    const associaPrenotazione = async (idSfida, idPrenota) => {

        const res = await fetchWithAuth(
            "classifica_mobile_associa_prenotazione.php",
            {
                method: "POST",
                body: JSON.stringify({
                    IDSfida: idSfida,
                    IDPrenota: idPrenota
                })
            }
        );

        if (res.ok) {

            showAlert(
                "Successo",
                "Prenotazione associata alla sfida"
            );

            caricaSfide();
            onAggiornaClassifica();

        } else {

            showAlert("Errore", res.error);
        }
    };

    const inviaRisultato = async (idSfida, vincitoreID) => {

        if (!window.confirm("Confermare il risultato?")) return;

        const res = await fetchWithAuth(
            "classifica_mobile_inserisci_risultato.php",
            {
                method: "POST",
                body: JSON.stringify({
                    IDSfida: idSfida,
                    Vincitore_ID: vincitoreID
                })
            }
        );

        if (res.ok) {

            showAlert(
                "Successo",
                "Risultato inserito e classifica aggiornata"
            );

            caricaSfide();
            onAggiornaClassifica();

        } else {

            showAlert("Errore", res.error);
        }
    };

    const rispondiSfida = async (idSfida, azione) => {

        const res = await fetchWithAuth(
            "classifica_mobile_risposta_sfida.php",
            {
                method: "POST",
                body: JSON.stringify({
                    IDSfida: idSfida,
                    azione
                })
            }
        );

        if (res.ok) {

            showAlert(
                "Successo",
                `Sfida ${azione === "accetta"
                    ? "accettata"
                    : "rifiutata"}`
            );

            caricaSfide();
            onAggiornaClassifica();

        } else {

            showAlert("Errore", res.error);
        }
    };

    const sfideFiltrate = sfide
        .filter(sfida => {
            if (filtroStato === "tutte") return true;
            return sfida.Stato === filtroStato;
        })
        .sort(
            (a, b) =>
                new Date(b.DataLancio) -
                new Date(a.DataLancio)
        );

    return (
        <Popup
            id="popup-sfide"
            title="Le tue sfide"
            onClose={onClose}
        >

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: 20
                }}
            >
                <select
                    value={filtroStato}
                    onChange={(e) =>
                        setFiltroStato(e.target.value)
                    }
                >
                    <option value="tutte">
                        Tutte
                    </option>

                    <option value="in_attesa">
                        In attesa
                    </option>

                    <option value="accettata">
                        Accettate
                    </option>

                    <option value="giocata">
                        Giocate
                    </option>

                    <option value="rifiutata">
                        Rifiutate
                    </option>

                    <option value="persa_automatica">
                        Perse automatiche
                    </option>
                </select>
            </div>

            {loading && (
                <p>Caricamento...</p>
            )}

            {!loading && sfideFiltrate.length === 0 && (
                <p
                    style={{
                        textAlign: "center",
                        marginTop: 40
                    }}
                >
                    Nessuna sfida presente
                </p>
            )}

            {sfideFiltrate.map(sfida => {

                const vinceSfidante =
                    sfida.Stato === "persa_automatica"
                        ? true
                        : sfida.Vincitore_ID == sfida.SfidanteID;

                const vinceSfidato =
                    sfida.Stato === "persa_automatica"
                        ? false
                        : sfida.Vincitore_ID == sfida.SfidatoID;

                return (
                    <div
                        className="card-sfida"
                        key={sfida.IDSfida}
                    >

                        <h3>
                            {sfida.sfidante_nome}
                            {" vs "}
                            {sfida.sfidato_nome}
                        </h3>

                        <p>
                            Stato:{" "}
                            <b>
                                {sfida.Stato === "in_attesa"
                                    ? "in attesa"
                                    : sfida.Stato === "persa_automatica"
                                        ? "persa automaticamente"
                                        : sfida.Stato}
                            </b>

                            <br />

                            Scadenza:{" "}
                            <b>{sfida.Scadenza}</b>
                        </p>

                        {sfida.Stato === "giocata" &&
                            sfida.pren_data && (
                                <p>
                                    Giocata il:{" "}
                                    <b>
                                        {sfida.pren_data}
                                        {" ("}
                                        {sfida.pren_ora}
                                        {")"}
                                    </b>
                                </p>
                            )
                        }

                        {sfida.Stato === "in_attesa" &&
                            sfida.SfidanteID == persona.id && (
                                <div style={{ marginBottom: 10 }}>
                                    <button
                                        className="rimuovi"
                                        onClick={() =>
                                            ritiraSfida(
                                                sfida.IDSfida
                                            )
                                        }
                                    >
                                        Ritira
                                    </button>
                                </div>
                            )
                        }

                        {sfida.Stato === "in_attesa" &&
                            sfida.SfidatoID == persona.id && (
                                <div style={{ marginBottom: 10 }}>

                                    <button
                                        className="conferma"
                                        onClick={() =>
                                            rispondiSfida(
                                                sfida.IDSfida,
                                                "accetta"
                                            )
                                        }
                                        style={{
                                            marginRight: 10
                                        }}
                                    >
                                        Accetta
                                    </button>

                                    <button
                                        className="rimuovi"
                                        onClick={() =>
                                            rispondiSfida(
                                                sfida.IDSfida,
                                                "rifiuta"
                                            )
                                        }
                                    >
                                        Rifiuta
                                    </button>

                                </div>
                            )
                        }

                        {sfida.Stato === "accettata" &&
                            !sfida.IDPrenota && (
                                <div>

                                    <label>
                                        Associa prenotazione:
                                    </label>

                                    <select
                                        onChange={(e) =>
                                            e.target.value &&
                                            associaPrenotazione(
                                                sfida.IDSfida,
                                                e.target.value
                                            )
                                        }
                                        defaultValue=""
                                    >
                                        <option value="">
                                            -- seleziona --
                                        </option>

                                        {prenotazioni.map(p => (
                                            <option
                                                key={p.IDPrenota}
                                                value={p.IDPrenota}
                                            >
                                                {p.data}
                                                {" "}
                                                {p.ora}
                                                {" - "}
                                                {p.nomeCampo}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            )
                        }

                        {sfida.IDPrenota && (
                            <p>
                                Prenotazione:
                                <br />

                                <b>{sfida.pren_data}</b>

                                {" - "}

                                <b>{sfida.pren_ora}</b>

                                <br />

                                Campo:{" "}

                                <b>{sfida.pren_campo}</b>
                            </p>
                        )}

                        {(sfida.Stato === "giocata" ||
                            sfida.Stato === "rifiutata" ||
                            sfida.Stato === "persa_automatica") && (
                            <>

                                {sfida.Stato === "rifiutata" ? (
                                    <p>
                                        Esito: <b>Sfida rifiutata</b>
                                    </p>
                                ) : (
                                    <p>
                                        Vincitore:{" "}
                                        <b>
                                            {vinceSfidante
                                                ? sfida.sfidante_nome
                                                : sfida.sfidato_nome}
                                        </b>
                                    </p>
                                )}

                                <p>
                                    Nuove posizioni:
                                    <br />

                                    {sfida.sfidante_nome}: {sfida.pos_sfidante}
                                    <br />

                                    {sfida.sfidato_nome}: {sfida.pos_sfidato}
                                </p>

                            </>
                        )}

                        {persona.maestro &&
                            sfida.Stato === "accettata" &&
                            sfida.IDPrenota && (
                                <div
                                    style={{
                                        marginTop: 10
                                    }}
                                >

                                    <label>
                                        Risultato:
                                    </label>

                                    <br />

                                    <button
                                        className="conferma"
                                        onClick={() =>
                                            inviaRisultato(
                                                sfida.IDSfida,
                                                sfida.SfidanteID
                                            )
                                        }
                                        style={{
                                            marginBottom: 8
                                        }}
                                    >
                                        Vince {sfida.sfidante_nome}
                                    </button>

                                    <button
                                        className="conferma"
                                        onClick={() =>
                                            inviaRisultato(
                                                sfida.IDSfida,
                                                sfida.SfidatoID
                                            )
                                        }
                                        style={{
                                            marginBottom: 20
                                        }}
                                    >
                                        Vince {sfida.sfidato_nome}
                                    </button>

                                </div>
                            )
                        }

                    </div>
                );
            })}
        </Popup>
    );
};

export default PopupSfide;